import { atom } from 'jotai'

export type TNetworkError = '' | 'NETWORK' | 'TOKEN'
export const networkErrorAtom = atom<TNetworkError>('')
